import { lazy } from 'react';

export const NotImplemented = lazy(() => import('./NotImplemented'));
